import { Settings } from "lucide-react";
import CollectionNameInput from "./CollectionNameInput";
import CollectionSlugInput from "./CollectionSlugInput";
import CollectionChildrenCombobox from "./CollectionChildrenCombobox";
import CollectionTitleRecordInput from "./CollectionTitleRecordInput";
import CollectionVisibility from "./CollectionVisibility";
import CollectionPinToggle from "./CollectionPinToggle";
import CollectionDeleteDialog from "./CollectionDeleteDialog";
import CollectionTransfer from "./CollectionTransfer";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../sheet";
import { Button } from "../button";
import { useCollection, useIsOwnSpace } from "@/api/hooks";

export default function CollectionSettingsButton() {
  const collection = useCollection();
  const isOwnSpace = useIsOwnSpace();
  // Every control in the sheet writes to the collection, and all of them are
  // owner-only server-side.
  if (!collection || !isOwnSpace) return;
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="sm">
          <Settings />
          Configure collection
        </Button>
      </SheetTrigger>

      <SheetContent
        className="max-sm:inset-0 max-sm:w-full max-sm:border-l-0 sm:w-[380px] sm:max-w-[380px] overflow-y-auto"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <SheetHeader className="px-5 pt-[18px] pb-3 border-b">
          <SheetTitle
            className="text-[18px] font-semibold text-foreground"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            Collection settings
          </SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-[18px] px-5 pt-4 pb-5">
          <CollectionNameInput />
          <CollectionSlugInput />
          <CollectionTitleRecordInput />
          <CollectionChildrenCombobox />
          {/* Public visibility — styled as a bordered card */}
          <div className="rounded-[10px] bg-secondary border border-border px-4 py-3">
            <CollectionVisibility />
          </div>
          {/* Pin to sidebar */}
          <div className="rounded-[10px] bg-secondary border border-border px-4 py-3">
            <CollectionPinToggle />
          </div>
          <CollectionTransfer />
          {/* Danger zone */}
          <div className="rounded-[10px] border border-destructive bg-[oklch(0.975_0.012_25)] dark:bg-[oklch(0.22_0.012_25)] px-4 py-3 flex flex-col gap-3">
            <p className="text-[11px] font-bold uppercase tracking-[.06em] text-destructive">
              Danger zone
            </p>
            <CollectionDeleteDialog />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
